import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { FormGroup } from '@blueprintjs/core';
import { fetchAllVendors, fetchVendorProducts } from 'actions/vendor-request';
import Row from 'containers/Reports/row';
import { runOutstandingAssessmentsReport } from 'actions/reports';
import clone from 'lodash/clone';

const transformDataForReport = reports => {
  const newReports = clone(reports);
  reports.map(report => {
    Object.defineProperty(report, 'contactName', {
      value: `${report.vendorContactFirstName} ${report.vendorContactLastName}`,
    });

    Object.defineProperty(report, 'sponsorName', {
      value: `${report.sponsorFirstName} ${report.sponsorLastName}`,
    });

    Object.defineProperty(report, 'stringRequestingDepartments', {
      value: JSON.stringify(report.departmentsRequesting).replace(
        /[[\]"]+/g,
        ''
      ),
    });
    return report;
  });
  return newReports;
};

const OutstandingAssessmentsBase = ({
  fetchAllVendors,
  fetchVendorProducts,
  vendors,
  products,
  runOutstandingAssessmentsReport,
  report,
  isLoadedVendors,
  ...rest
}) => {
  const [selectedVendor, setVendor] = useState(null);
  const [selectedProduct, setProduct] = useState(null);

  const handleChange = (selected, setter) => {
    setter(selected);
  };

  useEffect(() => {
    if (!!selectedVendor) {
      fetchVendorProducts(selectedVendor.vendorID);
    }
    setProduct(null);
  }, [selectedVendor]);
  return (
    <Row
      name="Outstanding Assessments"
      description="Assessments that haven't been completed by the Third Party within 30 days. This can be used to encourage them to complete the assessment before the 45 day expiration deadline."
      drawer={
        <div style={{ width: '50%' }}>
          <FormGroup label="Third Party">
            <Select
              options={vendors}
              getOptionLabel={option => option.vendorName}
              getOptionValue={option => option.vendorID}
              value={selectedVendor}
              onChange={selected => handleChange(selected, setVendor)}
            />
          </FormGroup>
          <FormGroup label="Product / Service">
            <Select
              options={selectedVendor ? products : []}
              getOptionLabel={option => option.productServiceName}
              getOptionValue={option => option.productServiceName}
              value={selectedProduct}
              onChange={selected => handleChange(selected, setProduct)}
            />
          </FormGroup>
        </div>
      }
      runReport={() =>
        runOutstandingAssessmentsReport({
          vendorName: selectedVendor ? selectedVendor.vendorName : null,
          productServiceName: selectedProduct
            ? selectedProduct.productServiceName
            : null,
        })
      }
      data={transformDataForReport(report)}
      headers={[
        { label: 'Assessment ID', key: 'vendorRequestID' },
        { label: 'Third Party Name', key: 'vendorName' },
        { label: 'Third Party Contact', key: 'contactName' },
        { label: 'Product / Service', key: 'productServiceName' },
        { label: 'Status', key: 'requestStatus' },
        { label: 'Date Created', key: 'requestSubmittedDate' },
        { label: 'Sponsor Name', key: 'sponsorName' },
        { label: 'Sponsor Department', key: 'sponsorDepartment' },
        { label: 'Requesting Department', key: 'stringRequestingDepartments' },
        { label: 'Date of Expiration', key: 'expirationDate' },
      ]}
      resetDrawerState={() => {
        setVendor(null);
        setProduct(null);
      }}
      fetchReportFieldsData={() => {
        if (!isLoadedVendors) {
          fetchAllVendors();
        }
      }}
      {...rest}
    />
  );
};

const mapStateToProps = state => ({
  vendors: state.vendorRequest.vendors,
  products: state.vendorRequest.products,
  report: state.reports.outstandingAssessments,
  isFetchingReport: state.reports.isFetching,
  isLoadedReport: state.reports.isLoaded,
  errorMessage: state.reports.errorMessage,
  isLoadedVendors: state.isVendorsLoaded,
});

const OutstandingAssessments = connect(
  mapStateToProps,
  { fetchAllVendors, fetchVendorProducts, runOutstandingAssessmentsReport }
)(OutstandingAssessmentsBase);

export default OutstandingAssessments;
